import { render } from "preact";
import { App } from "./App.jsx";

import "../styles/tokens.css";
import "../styles/base.css";
import "../styles/layout.css";
import "../styles/motion.css";

if (import.meta.env.PROD && !document.querySelector('script[data-website-id="d9e944af-3c2f-4b5d-93b8-816a9b5a7115"]')) {
  const analyticsScript = document.createElement("script");
  analyticsScript.defer = true;
  analyticsScript.src = "https://analytics.dannyb.co/script.js";
  analyticsScript.dataset.websiteId = "d9e944af-3c2f-4b5d-93b8-816a9b5a7115";
  document.head.appendChild(analyticsScript);
}

render(<App />, document.getElementById("app"));
